<template>
	<v-dialog v-model="dialog" :max-width="maxWidth" :overlay-opacity="overlayOpacity">
		<template v-slot:activator="{ on, attrs }">
			<slot name="open-btn">
				<v-btn
					v-if="onlyIcon"
					icon
					:fab="openBtnDesign.includes('fab') ? true : false"
					:outlined="openBtnDesign.includes('outlined') ? true : false"
					:fixed="openBtnDesign.includes('fixed') ? true : false"
					:absolute="openBtnDesign.includes('absolute') ? true : false"
					:shaped="openBtnDesign.includes('shaped') ? true : false"
					:rounded="openBtnDesign.includes('rounded') ? true : false"
					:right="openBtnDesign.includes('right') ? true : false"
					:top="openBtnDesign.includes('top') ? true : false"
					:left="openBtnDesign.includes('left') ? true : false"
					:bottom="openBtnDesign.includes('bottom') ? true : false"
					:color="openBtnColor"
					small
					:style="openBtnStyle"
					:class="openBtnClass"
					:text="false"
					@click.stop="dialog = true"
					v-bind="attrs"
					v-on="on"
				>
					<slot name="icon">
						<v-icon>mdi-delete</v-icon>
					</slot>
				</v-btn>
				<v-btn
					v-else
					:text="openBtnDesign.includes('text') ? true : false"
					:outlined="openBtnDesign.includes('outlined') ? true : false"
					:dark="openBtnDesign.includes('dark') ? true : false"
					:color="openBtnColor"
					:style="openBtnStyle"
					:class="openBtnClass"
					@click.stop="dialog = true"
					v-bind="attrs"
					v-on="on"
				>
					<slot name="icon">
						<v-icon class="mr-1">mdi-delete</v-icon>
					</slot>
					<slot name="btn-text"> 削除する </slot>
				</v-btn>
			</slot>
		</template>

		<v-card>
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">
					<slot name="title"> 本当に削除しますか </slot>
				</v-app-bar-title>
				<v-spacer />
				<v-btn v-if="$vuetify.breakpoint.xs" @click="dialog = false" icon>
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>
			<v-card-text class="pa-2 black--text">
				<slot name="text"> 削除すると元に戻すことはできません。<br />本当によろしいですか。 </slot>
				<v-text-field
					v-if="confirm"
					v-model="confirmText"
					class="mt-4"
					:rules="[confirmText == '削除' || '確認のため「削除」と入力してください。']"
					hint="確認のため「削除」と入力してください。"
					persistent-hint
					dense
					outlined
				/>
			</v-card-text>
			<v-card-actions>
				<v-row no-gutters justify="center">
					<v-col sm="2" cols="0" />
					<v-col sm="8" cols="12">
						<slot name="button">
							<v-row justify="center">
								<v-btn
									class="ma-1"
									@click="deleteMethod != null ? deleteMethod() : deleteItem()"
									dense
									:dark="!disabled"
									:color="deleteBtnColor"
									:disabled="disabled"
									>{{ deleteBtnText }}</v-btn
								>
							</v-row>
						</slot>
					</v-col>
					<v-col sm="2" cols="0">
						<v-row no-gutters align="center">
							<v-spacer></v-spacer>
							<v-btn
								v-if="!$vuetify.breakpoint.xs"
								color="grey darken-1"
								text
								@click="dialog = false"
							>
								キャンセル
							</v-btn>
						</v-row>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import errorHandling from "../../helper/errorHandling"
import authenticate from "../../helper/authenticate"

export default {
	props: {
		// 削除するボタンを押したときにアクセスするURL
		url: {
			type: String,
			default: null,
			required: false,
		},
		// ダイアログ外部分Opacity
		overlayOpacity: {
			type: String,
			default: "0.7",
			required: false,
		},
		// ダイアログを開くボタンのデザインを配列で受け取る
		openBtnDesign: {
			type: Array,
			default: () => [],
			required: false,
		},
		// ダイアログを開くボタンの色
		openBtnColor: {
			type: String,
			default: "secondary",
			required: false,
		},
		// 削除メソッドが呼び出されるボタンの色
		deleteBtnColor: {
			type: String,
			default: "red",
			required: false,
		},
		// ダイアログを開くボタンのStyleを受け取る。
		openBtnStyle: {
			type: Object,
			default: null,
			required: false,
		},
		// ダイアログを開くボタンのclassを受け取る。
		openBtnClass: {
			type: String,
			default: "",
			required: false,
		},
		// ダイアログのmax-width
		maxWidth: {
			type: String,
			default: "700px",
			required: false,
		},
		// 削除するボタンを押したときのメソッド
		deleteMethod: {
			type: Function,
			required: false,
			default: null,
		},
		// 削除メソッドが呼び出されるボタンのテキスト
		deleteBtnText: {
			type: String,
			required: false,
			default: "削除する",
		},
		// ダイアログが開くボタンのアイコンのみを指定
		onlyIcon: {
			type: Boolean,
			required: false,
			default: false,
		},
		// テキストフィールドを表示させ、「削除」と打たないと削除できない。
		confirm: {
			type: Boolean,
			required: false,
			default: false,
		},	
		requiredBtn:{
			type: Boolean,
			required: false,
			default: true,
		}
	},
	data() {
		return {
			dialog: false,
			confirmText: null,
		}
	},
	methods: {
		deleteItem() {
			const headers = authenticate.setHeader()
			axios
				.delete(this.url, { headers })
				.then((res) => {
					this.$store.dispatch("setFlash", {
						text: "削除しました。",
						type: "notice",
					})
					this.closeDialog()
					this.$emit("success-delete", res.data)
				})
				.catch((err) => {
					this.$emit("fail-delete", err)
					errorHandling.errorResponse(err)
				})
		},
		closeDialog() {
			this.dialog = false
		},
	},
	computed: {
		disabled() {
			return this.confirm && this.confirmText != "削除"
		},
	},
}
</script>
